<template>
	<div v-if="condition" v-cloak>
		<div class="modal-backdrop"></div>
		<div class="gc-modal__wrapper" @click.self="onBackdropClick">
			<slot name="modalInner">
				<div class="gc-modal-inner" :class="modalClass">
					<div class="gc-modal__header">
						<slot name="header">
							<h4 class="gc-modal__message--title">
								<slot name="messageTitle">Are you sure?</slot>
							</h4>
							<a @click="$emit('cancel')" class="gc-modal__close">×</a>
						</slot>
					</div>
					<div class="gc-modal__body" :class="bodyClass">
						<slot name="body">
							<p class="gc-modal__message--body">
								<slot name="messageMain"></slot>
							</p>
							<p class="gc-modal__message--body gc-modal__message--body--alert">
								<slot name="messageInfo"></slot>
							</p>
						</slot>
					</div>
					<div class="gc-modal__footer">
						<slot name="footer">
							<a class="gc-modal__cancel" @click="$emit('cancel')">
								<slot name="cancelText">Cancel</slot>
							</a>
							<a class="btn btnRed" @click="$emit('ok')">
								<slot name="confirmText">OK</slot>
							</a>
						</slot>
					</div>
				</div>
			</slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'GcModal',
		props: ['condition', 'options', 'modalClass', 'bodyClass'],
		data: function () {
			return {
				opts: {
					closeOnEscape: true,
					disableBackdropClick: false
				}
			};
		},
		methods: {
			escapeKeyHandler: function (event) {
				let key = event.which || event.keyCode;
				if (key === 27) {
					this.$emit('cancel');
				}
			},
			onBackdropClick: function () {
				if (!this.opts.disableBackdropClick) {
					this.$emit('cancel')
				}
			}
		},
		mounted: function () {
			this.modalBodyClass = 'gc-modal-active';

			if (this.options) this.opts = this.options;

			if (this.condition) {
				document.body.classList.add(this.modalBodyClass);
			}

			if (this.opts.closeOnEscape) {
				window.addEventListener('keyup', this.escapeKeyHandler);
			}
		},
		destroyed: function () {
			if (this.opts.closeOnEscape) {
				window.removeEventListener('keyup', this.escapeKeyHandler);
			}
			document.body.classList.remove(this.modalBodyClass);
		},
		watch: {
			condition: function (newValue) {
				if (newValue) {
					document.body.classList.add(this.modalBodyClass);
				} else {
					document.body.classList.remove(this.modalBodyClass);
				}
			}
		}
	}
</script>